import { render, staticRenderFns } from "./InformationItem.vue?vue&type=template&id=669cebca"
import script from "./InformationItem.vue?vue&type=script&lang=js"
export * from "./InformationItem.vue?vue&type=script&lang=js"
import style0 from "./InformationItem.vue?vue&type=style&index=0&id=669cebca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports